import {
  Card,
  DataStatus,
  FormField,
  Flag,
  FormControl,
  Attributes,
  Separator,
} from 'platform/components';
import {Clickable, Heading, HStack, Show, Text, VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import {PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponse} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {suffixTestId, RequiredTestIdProps, EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

import {FormSchema} from '../types/FormSchema';
import {useAttributesData} from '../utils/useAttributesData';

type Group = NonNullable<
  NonNullable<
    NonNullable<PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponse>['groups']
  >[number]
>;

interface DataCardProps extends RequiredTestIdProps {
  index: number;
  formApi: UseFormReturn<FormSchema>;
  control: FormControl<FormSchema>;
  group: Group;
  comparedGroup: Group | Nullish;
}

export const DataCard = (props: DataCardProps) => {
  const data = useAttributesData(props.group?.type, props.group.attributes);
  const comparedData = useAttributesData(props.group?.type, props.comparedGroup?.attributes);

  return (
    <Clickable
      onClick={() =>
        props.formApi.setValue(`groups.${props.index}.selectedSource`, props.group.selectedSource)
      }
      height="100%"
      data-testid={suffixTestId('clickable', props)}
    >
      <Card
        variant={props.group.selectedSource === 'OMNETIC' ? 'inlineGrey' : 'inlineWhite'}
        colorStripe={props.group?.action === 'DELETE' ? 'red' : undefined}
        isFullHeight
      >
        <HStack justify="space-between" align="center" width="100%" height="100%">
          <VStack spacing={4} height="100%" width="100%">
            <HStack spacing={2} align="center">
              <FormField
                type="radio"
                control={props.control}
                name={`groups.${props.index}.selectedSource`}
                options={[{label: '', value: props.group.selectedSource}]}
                data-testid={suffixTestId('radio', props)}
              />
              <Heading size={4} data-testid={suffixTestId('heading', props)}>
                {i18n.t(`entity.integration.labels.${props.group.selectedSource.toLowerCase()}`)}
              </Heading>
              <Show when={props.group.action === 'DELETE'}>
                <Flag label={i18n.t('general.labels.deleted')} colorScheme="red" size="small" />
              </Show>
            </HStack>
            <Show when={props.group.comment || props.comparedGroup?.comment}>
              <Text size="xSmall" color="secondary">
                {props.group.comment ?? EMPTY_PLACEHOLDER}
              </Text>
              <Separator spacing={0} />
            </Show>
            <DataStatus
              isEmpty={!data || props.group.action === 'DELETE'}
              grow={1}
              minHeight="100%"
            >
              <Attributes
                rows={data?.map((item, index) => ({
                  label: item.label,
                  content: (
                    <Text
                      size="xSmall"
                      color={
                        props.group.action !== 'CREATE' &&
                        item.value !== comparedData?.[index]?.value
                          ? 'danger'
                          : 'secondary'
                      }
                    >
                      {item.value}
                    </Text>
                  ),
                }))}
              />
            </DataStatus>
          </VStack>
        </HStack>
      </Card>
    </Clickable>
  );
};
